import CheckInput from '../CheckInput';
import './permissions.css';

function Permissions({ permissions = [], onChangeModulePermission = () => {} }) {
    const modulePermissions = permissions.filter(p => !p.supplementary);

    return (
        <>
            {modulePermissions.map((p) => (
                <>
                    <CheckInput
                        title={p.name}
                        value={p.checked}
                        onChange={() => onChangeModulePermission(p)}
                    />
                </>
            ))}
        </>
    );
}

export default Permissions;